import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';
import { CommonDialogService } from '@core/common-dialog/common-dialog.service';
import { TranslationService } from '@core/services/translation.service';
import { BaseComponent } from 'src/app/base.component';
import { ToastrService } from 'ngx-toastr';
import { AddEditCategoryDialogComponent } from './add-edit-category-dialog/add-edit-category-dialog.component';
import { GrpserviceService } from '../grpservice.service';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-category-grp',
  templateUrl: './category-grp.component.html',
  styleUrls: ['./category-grp.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class CategoryGrpComponent extends BaseComponent implements OnInit {
  columnsToDisplay: string[] = ['expand', 'name', 'status', 'action'];
  subCategoryColumns: string[] = ['name', 'status', 'action'];
  categories: any[] = [];
  subCategories: any[] = [];
  expandedElement: any = null;
  totalItems = 0;
  pageSize = 10;
  pageIndex = 0;

  constructor(
    private dialog: MatDialog,
    private commonDialogService: CommonDialogService,
    private cd: ChangeDetectorRef,
    private toastrService: ToastrService,
    private categoryService: GrpserviceService,
    public translationService: TranslationService
  ) {
    super(translationService);
  }

  ngOnInit(): void {
    this.getCategories(this.pageIndex, this.pageSize);
  }

  getCategories(pageIndex: number, pageSize: number): void {
    this.categoryService.getSubjectList(pageIndex + 1, pageSize).subscribe(
      (res: any) => {
        this.categories = res.data?.items || res.items || [];
        this.totalItems = res.data?.totalRecords || res.totalRecords || 0;
        this.pageIndex = pageIndex;
        this.pageSize = pageSize;
        this.cd.detectChanges();
      },
      (error) => {
        console.error('Error loading categories:', error);
        this.toastrService.error('Failed to load categories');
        this.categories = [];
        this.totalItems = 0;
      }
    );
  }

  manageCategory(category: any): void {
    const dialogRef = this.dialog.open(AddEditCategoryDialogComponent, {
      width: '400px',
      disableClose: true,
      data: { ...category },
    });

    this.sub$.sink = dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getCategories(this.pageIndex, this.pageSize);
        // If we had an expanded row, reload its subcategories
        if (
          this.expandedElement &&
          this.expandedElement.id === category.categoryId
        ) {
          this.loadSubCategories(this.expandedElement);
        }
      }
    });
  }

  toggleRow(element: any): void {
    if (this.expandedElement === element) {
      this.expandedElement = null;
      this.subCategories = [];
    } else {
      this.loadSubCategories(element);
    }
  }

  private loadSubCategories(category: any): void {
    this.categoryService.getSubCategories(category.id).subscribe(
      (res: any) => {
        // Handle different response structures
        this.subCategories = res.data?.items || res.data || res || [];
        this.expandedElement = category;
        this.cd.detectChanges();
      },
      (error) => {
        console.error('Error loading subcategories:', error);
        this.toastrService.error('Failed to load subcategories');
        this.subCategories = [];
        this.expandedElement = category;
        this.cd.detectChanges();
      }
    );
  }

  addSubCategory(category: any): void {
    this.manageCategory({
      id: null,
      name: '',
      subCategoryName: '',
      categoryId: category.id,
      isActive: 1,
      isEnabled: 1,
      nIndex: 0,
    });
  }

  editSubCategory(subCategory: any, categoryId: any): void {
    this.manageCategory({
      ...subCategory,
      categoryId: categoryId,
    });
  }
  onPageChange(event: PageEvent): void {
    this.getCategories(event.pageIndex, event.pageSize);
  }
}
